'use client'

import { IconArrowRight } from '@tabler/icons-react'
import clsx from 'clsx'

import { theme } from 'shared/ui/utils/designTokens'

import styles from './SubmitEditSaleOrderModalChangedItem.module.scss'

type SubmitEditSaleOrderModalChangedItem = {
  changedTitle: string
  firstStartLabel: string
  secondStartLabel?: string | null
  firstStartElement?: string | null
  secondStartElement?: string | null
  thirdStartElement?: string | null
  secondChangedLabel?: string | null
  firstChangedElement?: string | null
  secondChangedElement?: string | null
  thirdChangedElement?: string | null
}

const SubmitEditSaleOrderModalChangedItem = ({
  changedTitle,
  firstStartLabel,
  secondStartLabel,
  firstStartElement,
  secondStartElement,
  thirdStartElement,
  firstChangedElement,
  secondChangedLabel,
  secondChangedElement,
  thirdChangedElement
}: SubmitEditSaleOrderModalChangedItem) => {
  return (
    <div className={styles.detailsItem}>
      <p className={styles.detailsItemLabel}>{changedTitle}</p>
      <div className={styles.detailsCard}>
        <div className={styles.smallTextWrapper}>
          <p className={styles.smallText}>{firstStartLabel}</p>
          {firstStartElement && (
            <p className={clsx(styles.smallText, styles.smallTextBold)}>
              {firstStartElement}
            </p>
          )}

          {secondStartLabel && (
            <p className={styles.smallText}>{secondStartLabel}</p>
          )}

          {secondStartElement && (
            <p className={clsx(styles.smallText, styles.smallTextBold)}>
              {secondStartElement}
            </p>
          )}

          {thirdStartElement && (
            <p className={clsx(styles.smallText, styles.smallTextBold)}>
              {thirdStartElement}
            </p>
          )}
        </div>
        <div className={styles.smallTextWrapper}>
          <IconArrowRight color={theme.colors.brand.secondary} />
        </div>
        <div className={styles.smallTextWrapper}>
          <p className={styles.smallText}>Zmieniasz na:</p>

          {firstChangedElement && (
            <p className={clsx(styles.smallText, styles.smallTextBold)}>
              {firstChangedElement}
            </p>
          )}

          {secondChangedLabel && (
            <p className={styles.smallText}>{secondChangedLabel}</p>
          )}

          {secondChangedElement && (
            <p className={clsx(styles.smallText, styles.smallTextBold)}>
              {secondChangedElement}
            </p>
          )}

          {thirdChangedElement && (
            <p className={clsx(styles.smallText, styles.smallTextBold)}>
              {thirdChangedElement}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default SubmitEditSaleOrderModalChangedItem
